import { graphql } from "../gql/index.ts";
import { useMutation } from "@apollo/client";
import { useCallback } from "react";

const AddParticipantsToClassRoomMutation = graphql(`
  mutation addParticipantsToClassByEmail(
    $classRoomId: String!
    $emails: [String!]!
    $skipLevelCheck: Boolean
  ) {
    addParticipantsToClassByEmail(
      classRoomId: $classRoomId
      userEmails: $emails
      skipLevelCheck: $skipLevelCheck
    ) {
      ...ClassRoomWithParticipants
    }
  }
`);
export function useAddParticipantsToClassRoom() {
  const [addParticipantsToClassRoomMutation, { loading }] = useMutation(
    AddParticipantsToClassRoomMutation,
  );

  const addParticipantsToClassRoom = useCallback(
    async ({
      classRoomId,
      emails,
      skipLevelCheck,
    }: {
      classRoomId: string;
      emails: string[];
      skipLevelCheck?: boolean;
    }) => {
      await addParticipantsToClassRoomMutation({
        variables: { classRoomId, emails, skipLevelCheck },
      });
    },
    [addParticipantsToClassRoomMutation],
  );

  return {
    addParticipantsToClassRoom,
    loading,
  };
}
